'use strict';

module.exports = require('./src/jquery/plugin.js');



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/index_jquery.js
// module id = 594
// module chunks = 0